import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

/**
 * Whether to route this provider to the new management hub.
 *
 * `isManagementHubMigrated` is the server-computed
 * `should_show_new_management_hub`: the migration rollout applies AND the
 * provider is in a management state. The `rollout_management_hub_migration`
 * gate alone is location-only and true for SSU applicants too, who must never
 * be sent to a hub that replaces a hub they have not reached yet.
 *
 * Reads `false` until the current user resolves. Callers that act on a negative
 * answer rather than merely picking a destination -- e.g. dismissing a screen --
 * must gate on `useCurrentUser().isLoading` first.
 */
export const useShouldShowNewManagementHub = (): boolean => {
  const { user } = useCurrentUser();

  return !!user?.isManagementHubMigrated;
};
